
import mapStyle from './mapStyle';
import { Loader } from '@googlemaps/js-api-loader';

class ApiMaps {
    constructor(coord,div, divTam) {
        if (coord === undefined) coord = {lat: 0,lng: 0};
        if (div === undefined) div = "map";
        if (divTam === undefined) divTam = "contInt";
        
        this.googleMapsAPIKey = "AIzaSyBr7ujs_lYA2DqdiQyfESv7zXq1L6DMc28";
        this.icon = "../img/beGrand-map-pin.png";
        
        this.divTam = divTam;
        this.conteinerDiv = div;
        
        this.loader = new Loader({
            apiKey: this.googleMapsAPIKey,           
        });
        
        this.coord = coord;

        this.mapOptions = {
            center: this.coord,
            zoom: 15,
            styles: mapStyle,
            disableDefaultUI: true,
            zoomControl: true,
            draggable: false
        }; 
        
        this.load();
    }
    load(){
        this.onResize();

        this.loader
            .load()
            .then(() => {
                /* crea el mapa */
                let map = new google.maps.Map(document.getElementById(this.conteinerDiv), this.mapOptions );
                
                /* crea el pin en el mapa */
                new google.maps.Marker({
                    position: this.coord,
                    map: map,
                    icon: this.icon
                });
            })
            .catch(e => {
                // do something
            });
    }
    onResize(){
        let containerDiv = window[this.conteinerDiv];
        let _height = window[this.divTam].getBoundingClientRect().height;

        containerDiv.style.minHeight = _height+"px";
    }
    

}

export default ApiMaps;


// WEBPACK FOOTER //
// ./resources/assets/js/modules/apiMaps.js